module.exports = __webpack_public_path__ + "static/media/parent_user.d9490c24.svg";